import {Dialog, Transition} from "@headlessui/react";
import {BlackButton} from "../../Buttons/BlackButton";
import {Fragment} from "react";
import {PrimaryButton} from "../../Buttons/PrimaryButton";
import {useTranslation} from "react-i18next";

export const AcceptConfirmDialog = (props) => {
    const {
        open,
        onClose,
        onConfirm
    } = props;

    const {t} = useTranslation();

    return (
        <>
            <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/50"/>
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        {t('dialogs.confirm.accept_title')}
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            {t('dialogs.confirm.accept_message')}<br/>
                                            {t('dialogs.confirm.cannot_undo')}
                                        </p>
                                    </div>

                                    <div className={'flex justify-end'}>
                                        <div className="mt-4 grid grid-cols-2 w-fit gap-4">
                                            <div>
                                                <BlackButton outlined={true} onClick={onClose}>{t('general.actions.cancel')}</BlackButton>
                                            </div>
                                            <PrimaryButton onClick={onConfirm}>{t('general.actions.accept')}</PrimaryButton>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}